import PropTypes from 'prop-types';

// @mui
import { Box, Card, Link, Typography, Stack, Popover, Paper, MenuList, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import ButtonAction from '../Button.js/SaveButton';
import { t } from 'i18next';
import { useState } from 'react';
import DeviceDetail from '../DrawerSidebar/DeviceDetail';
import ChangeQuantity from '../modal/ChangeQuantity';
import Label from '../label/Label';
import { toast } from 'react-toastify';
import { glb_sv } from 'src/utils';
import Iconify from '../iconify';
// utils

// ----------------------------------------------------------------------

const StyledProductImg = styled('img')({
    top: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
    padding: '10px',
    boxShadow: (theme) => theme.customShadows.dropdown,
    borderBottom: '1px solid #eeeeee',
});

// ----------------------------------------------------------------------

ProductCard.propTypes = {
    product: PropTypes.object,
};

export default function ProductCard({
    isBorrow = false,
    isGiveDevice = false,
    setData,
    product,
    functOnClick,
    isRegisterOnline = false,
    isHaveNote = true,
    sizeButtonAdd = 'large',
}) {
    const [visible, setVisible] = useState(false);
    const [quantity, setQuantity] = useState('0');
    const [note, setnote] = useState('');
    const [visibleExport, setVisibleExport] = useState(false);
    const [open, setOpen] = useState(false);
    const handleOpen = (event) => {
        setOpen(event.currentTarget);
    };

    const handleClick = (data) => {
        if (data?.qty > 0) {
            setVisibleExport(true);
        } else {
            setVisible(true);
            let str = isBorrow ? t('warning_quantity') + ' ' + t('please_check_list_giver') : t('warning_quantity');
            toast.warning(str);
        }
    };
    const renderProperty = (property) => {
        let str = '';
        if (property)
            for (let i = 0; i < property.length; i++) {
                if (property[i].checked)
                    if (i + 1 < property.length) {
                        str += property[i].labelDisplay + ', ';
                    } else {
                        str += property[i].labelDisplay;
                    }
            }
        return (
            <>
                {str}{' '}
                {str === '' || !str ? (
                    '--/--'
                ) : (
                    <span
                        onClick={handleOpen}
                        style={{
                            fontStyle: 'italic',
                            textDecoration: 'underline',
                            color: '#057a6b',
                            cursor: 'pointer',
                        }}
                    >
                        {t('detail')}
                    </span>
                )}
            </>
        );
    };

    return (
        <Card style={{}}>
            <ChangeQuantity
                note={note}
                setnote={setnote}
                quantity={quantity}
                setQuantity={setQuantity}
                product={product}
                callBackFunct={functOnClick}
                visible={visibleExport}
                setVisible={setVisibleExport}
                isRegisterOnline={isRegisterOnline}
                isHaveNote={isHaveNote}
            />
            <DeviceDetail
                isBorrow={product?.status_action !== '1' ? true : false}
                device={product}
                open={visible}
                setOpen={setVisible}
            />
            <Box sx={{ pt: '100%', position: 'relative' }}>
                {product?.check_inv_status === '0' ? (
                    <Label
                        variant="filled"
                        color={'error'}
                        sx={{
                            zIndex: 9,
                            top: 10,
                            left: 0,

                            position: 'absolute',
                            textTransform: 'uppercase',
                            padding: '5px 10px',
                        }}
                    >
                        {t('system_statistical')}
                    </Label>
                ) : (
                    ''
                )}
                <StyledProductImg
                    onClick={() => setVisible(true)}
                    alt={glb_sv.convertMultipleLanguages(product?.device_nm)}
                    src={
                        product?.img_device
                            ? `${glb_sv.urlGetProductImage(product?.img_device)}`
                            : `${glb_sv.urlGetProductImage(product?.pic_device)}`
                    }
                />
                <Stack>
                    {product?.device_nm && (
                        <>
                            {product?.min_no >= product?.qty || product?.max_no <= product?.qty ? (
                                <Label
                                    variant="filled"
                                    color={'warning'}
                                    sx={{
                                        zIndex: 9,

                                        bottom: '0%',
                                        left: '50%',
                                        transform: 'translate(-50%, 0%)',

                                        position: 'absolute',
                                        textTransform: 'uppercase',
                                        padding: '5px 10px',
                                    }}
                                >
                                    {product?.min_no >= product?.qty ? (
                                        <>
                                            {' '}
                                            <Iconify icon="material-symbols:warning-outline-rounded" />{' '}
                                            {t('warning_import')}
                                        </>
                                    ) : (
                                        <>
                                            {' '}
                                            <Iconify icon="material-symbols:warning-outline-rounded" />{' '}
                                            {t('warning_export')}
                                        </>
                                    )}
                                </Label>
                            ) : (
                                ''
                            )}
                        </>
                    )}
                </Stack>
            </Box>

            <Stack spacing={0.5} sx={{ p: 2 }}>
                <Link
                    color="primary"
                    underline="always"
                    sx={{ fontStyle: 'italic', cursor: 'pointer' }}
                    onClick={() => setVisible(true)}
                >
                    <Typography variant="subtitle1" noWrap>
                        {glb_sv.convertMultipleLanguages(product?.device_cd)}
                    </Typography>
                </Link>

                <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap={'wrap'}>
                    <Typography variant="subtitle1" sx={{ fontSize: '13px', color: 'text.secondary' }} noWrap>
                        <Typography
                            component="span"
                            variant="body1"
                            sx={{
                                fontSize: '14px',
                                color: 'text.disabled',
                            }}
                        >
                            {t('name')}:
                        </Typography>
                        &nbsp;
                        {glb_sv.convertMultipleLanguages(product?.device_nm)}
                    </Typography>{' '}
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap={'wrap'}>
                    <Typography variant="subtitle1" sx={{ fontSize: '13px', color: 'text.secondary' }}>
                        <Typography
                            component="span"
                            variant="body1"
                            sx={{
                                fontSize: '13px',
                                color: 'text.disabled',
                            }}
                        >
                            {t('quantity_category')}:
                        </Typography>
                        &nbsp; {product?.qty}
                    </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="center" paddingTop={2}>
                    {isGiveDevice ? (
                        <ButtonAction
                            fullWidth
                            size="large"
                            type="get"
                            disabled={product?.check_inv_status === '0' ? true : false}
                            title={t('give')}
                            onClick={() => handleClick(product)}
                        />
                    ) : (
                        <ButtonAction
                            fullWidth
                            size={sizeButtonAdd}
                            type="get"
                            title={t('add_category')}
                            disabled={product?.check_inv_status === '0' || product?.qty === 0 ? true : false}
                            onClick={() => handleClick(product)}
                        />
                    )}
                </Stack>
            </Stack>
        </Card>
    );
}
